<template>
	<div class="open-account-bank">

		<h1 class="h1_title">{{translate('bank_card_information')}}</h1>
		
		<van-form @submit="nextStep()">
			<h4 class="h4_title">{{translate('bank_card_upload')}}</h4>
			
			<div style="background-color: #FFFFFF;text-align: center;padding: 20px;">
				<van-image
					width="150"
					height="150"
					:src="bank_front_url"
					@click="call_bank_front_pic"
				/>
			</div>

			<h4 class="h4_title">{{translate('account_information')}}</h4>

			<van-field
				readonly
				clickable
				:label="translate('bank_of_deposit')"
				:value="indexBank > -1 ? banks[indexBank].text : ''"
				:placeholder="translate('please_enter')"
				@click="showBank = true"
				:rules="rules.bank_id"
				required
			/>

			<van-popup v-model="showBank" round position="bottom">
				<van-picker
					:title="translate('bank_of_deposit')"
					show-toolbar
					:columns="banks"
					:default-index="indexBank"
					@cancel="showBank = false"
					@confirm="onConfirmBank"
				/>
			</van-popup>

			<van-field 
				v-if="indexBank > -1 && formItem.bank_id == 0"
				v-model="formItem.bank_name" 
				:label="translate('other_banks')" 
				:placeholder="translate('please_enter')"
				:rules="rules.bank_name"
				required
			/>

			<van-field 
				v-model="formItem.bank_branch" 
				:label="translate('sub_branch')" 
				:placeholder="translate('please_fill_format_of_bank')"
				:rules="rules.bank_branch"
				required
			/>
			
			<van-field 
				v-model="formItem.bank_number" 
				:label="translate('bank_card_number')" 
				:placeholder="translate('please_enter')"
				:rules="rules.bank_number"
				required
			/>
			
			<div class="common_block">
				<van-button type="warning" block round native-type="submit">{{translate('submit_bank')}}</van-button>
			</div>
		</van-form>

	</div>
</template>

<script>
	export default {
		name: 'account_bank',
		data() {
			return {
				formItem: {
					bank_id: "",
					bank_name: "",
					bank_branch: "",
					bank_number: "",
					bank_front_pic: "",
				},

				rules: {
					bank_id: [
						{
							required: true,
							message: this.translate('please_select_the_account_bank'),
							trigger: 'onBlur'
						}
					],

					bank_name: [
						{
							required: true,
							message: this.translate('please_select_the_account_bank'),
							trigger: 'onBlur'
						}
					],

					bank_branch: [
						{
							required: true,
							message: this.translate('please_enter_your_branch'),
							trigger: 'onBlur'
						}
					],
					
					bank_number: [
						{
							required: true,
							message: this.translate('please_enter_bank_card_number'),
							trigger: 'onBlur'
						}
					],
				},

				token: "",
				
				showBank: false,

				resourceURL: this.$axios.defaults.resourceURL,
				
				bank_front_url: this.$axios.defaults.resourceURL + "images/icon_bank_add.png",
				
				indexBank: -1,
				banks: [],

				disabledSubmit: true,
				
			}
		},
		mounted() {
			
			if (this.$route.query.token == "" || this.$route.query.token == undefined) {
				this.$router.replace('/nologin')
			} else {
				this.token = this.$route.query.token
				
				// 将方法绑定到window下面，提供给外部调用
				window.set_bank_front_pic = this.set_bank_front_pic
				
				this.init()
			}
		},
		methods: {
			init(){
				this.$axios({
					method: 'post',
					url: 'account_open/banks'
				}).then ((res) => {
					if (res.success) {

						this.banks = res.data

						this.banks.push({
							bank_id: 0,
							text: this.translate('other')
						})
						
					}else{
						this.$toast.fail(res.error_text)
					}
				})
				
				this.$axios({
					method: 'post',
					url: 'account_open/info',
					data: {
						token: this.token
					}
				}).then ((res) => {
					if (res.success) {

						if (res.data.status == 2) {
							//	待审核
							this.$router.replace('/account/success')
						} else if (res.data.status == 3) {
							//	不通过
							this.$router.replace('/account/fail?token=' + this.token)
						} else {
							
							var bank_data = res.data.bank_data		
							
							if (bank_data.length != 0) {
								this.formItem.bank_id = bank_data.bank_id ? bank_data.bank_id : ""
								this.formItem.bank_name = bank_data.bank_name ? bank_data.bank_name : ""
								this.formItem.bank_branch = bank_data.bank_branch ? bank_data.bank_branch : ""
								this.formItem.bank_number = bank_data.bank_number ? bank_data.bank_number : ""
								this.formItem.bank_front_pic = bank_data.bank_front_pic ? bank_data.bank_front_pic : ""
								
								if (bank_data.bank_front_url) {
									this.bank_front_url = bank_data.bank_front_url
								}

								this.banks.forEach((item, key) => {
									if(item.bank_id == bank_data.bank_id){
										this.indexBank = key
									}								
								})
							}

						}

					}else{
						this.$toast.fail(res.error_text)
					}
				})

				
			},

			call_bank_front_pic(){
                if (window.JsObject != null) {
                    window.JsObject.callBankPic();
                }

                if (window.webkit != null) {
                    window.webkit.messageHandlers.jsToOcWithPrams.postMessage({"camera": "bank_front_pic"});
                }
			},
			
			/*   
             * 参数path：
             *     上传图片在服务器的路径
             */
            set_bank_front_pic(path){

				this.$axios({
					method: 'post',
					url: 'account_open/resize',
					data: {
						img: path
					}
				}).then ((res) => {
					if (res.success) {
						this.bank_front_url = res.thumb
						this.formItem.bank_front_pic = path
					}else{
						this.$toast.fail(this.translate('capture_failed'))
					}
				})
			},
			onConfirmBank(value, index) {

				if (value) {
					this.indexBank = index

					this.formItem.bank_id = this.banks[index].bank_id
				
					// 选择银行时，清除输入的银行名称
					this.formItem.bank_name = ''
				}
				
				this.showBank = false
			},
			nextStep(){

				if(this.formItem.bank_front_pic == '') {
					this.$toast.fail(this.translate('please_upload_bank_card'))
					return false
				}
				
				this.$axios({
					method: 'post',
					url: 'account_open/update',
					data: {
						token: this.token,
						bank_data: JSON.stringify(this.formItem)
					}
				}).then ((res) => {
					if (res.success) {
						// this.$router.push('/account/success')
						this.$router.push('/account/career?token=' + this.token)
					}else{
						this.$toast.fail(res.error_text)
					}
				})
				
			}
		},
	}
</script>